//region 1. Platform Libraries
import bodyParser from 'body-parser';
import express from 'express';
import MongoClient from 'mongodb';
//endregion

//region 2. Project Libraries
import checkObjectID from '../middleware/checkObjectID';
import checkStreamIndex from '../middleware/checkStreamIndex';
//endregion

const context = {
    router: express.Router({ mergeParams: true }),
    archiveVideos: null,
    logger: null,
};

context.router.use('/', checkObjectID);
context.router.use('/', checkStreamIndex);

context.router.get('/-1', (req, res) => {
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `GET ${req.originalUrl}` });
    context.archiveVideos.findOne({
        camera_id: new MongoClient.ObjectID(req.params.id),
        stream_index: parseInt(req.params.index, 10),
    }, { sort: { video_index: -1 } }, (err, result) => {
        if (err) {
            log('error', err.message);
            res.status(500).send(err.message);
            return;
        }
        const reply = { index: 0 };
        if (!result) {
            log('debug', JSON.stringify(reply, null, 2));
            res.status(200).send(reply);
            return;
        }
        reply.index = result.video_index;
        reply.startTime = result.started.getTime();
        reply.endTime = result.ended.getTime();
        reply.bucketName = result.bucket_name;
        reply.objectName = result.object_name;
        reply.status = result.status;
        reply.size = result.size;
        log('debug', JSON.stringify(reply, null, 2));
        res.status(200).send(reply);
    });
});

context.router.put('/', bodyParser.json());
context.router.put('/', (req, res) => {
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `PUT ${req.originalUrl}` });
    log('debug', JSON.stringify(req.body, null, 2));
    if (Object.keys(req.body).length === 0) {
        const message = 'No Request or Request Body';
        log('error', message);
        res.status(400).send(message);
        return;
    }
    const size = req.body.size;
    if (!size || typeof size !== 'number' || !Number.isInteger(size)) {
        const message = 'Invalid size value';
        log('error', message);
        res.status(400).send(message);
        return;
    }
    const doc = {
        camera_id: new MongoClient.ObjectID(req.params.id),
        stream_index: parseInt(req.params.index, 10),
        video_index: parseInt(req.body.index, 10),
        started: new Date(req.body.startTime),
        ended: new Date(req.body.endTime),
        bucket_name: req.body.bucketName,
        object_name: req.body.objectName,
        size: req.body.size,
    };
    context.archiveVideos.insertOne(doc, (err) => {
        if (err) {
            log('err', err.message);
            res.status(500).send(err.message);
            return;
        }
        log('info', '200 OK');
        res.sendStatus(200);
    });
});

/**
 * @param {string} req.params.videoIndex
 */
context.router.put('/:videoIndex/status', bodyParser.text());
context.router.put('/:videoIndex/status', (req, res) => {
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `PUT ${req.originalUrl}` });
    log('debug', req.body);
    if (req.body.length === 0) {
        const message = 'No Request or Request Body';
        log('error', message);
        res.status(400).send(message);
        return;
    }
    const status = { status: req.body };
    context.archiveVideos.updateOne({
        camera_id: new MongoClient.ObjectID(req.params.id),
        stream_index: parseInt(req.params.index, 10),
        video_index: parseInt(req.params.videoIndex, 10),
    }, { $set: status }, (err, result) => {
        if (err) {
            log('error', err.message);
            res.status(500).send(err.message);
            return;
        }
        if (result.matchedCount === 0) {
            const message = 'Camera Not Found';
            log('error', message);
            res.status(500).send(message);
            return;
        }
        log('info', '200 OK');
        res.sendStatus(200);
    });
});

//noinspection JSUnusedGlobalSymbols
/**
 * Mount router for /c/:/s/:/video-info
 * @param {object}         options          Options
 * @param {object}         options.app      Express App
 * @param {MongoClient.Db} options.database Associated Database
 * @param {winston.Logger} options.logger   Logger
 */
export default function mountVideoInfo(options) {
    context.logger = options.logger;
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'mountVideoInfo' });
    log('debug', 'Mounting router for /c/:/s/:/video-info....');
    options.app.use('/cameras/:id/streams/:index/video-info', context.router);
    context.archiveVideos = options.database.collection('archive_videos');
    context.archiveVideos.createIndexes([{
        camera_id: -1,
        stream_index: 1,
        video_index: -1,
    }, {
        camera_id: -1,
        video_index: 1,
    }], { background: true });
    log('info', 'Router for /c/:/s/:/video-info Mounted');
}
